import { useState } from "react";
import { Search, Mail, Phone, MessageCircle, LifeBuoy } from "lucide-react";
import FaqAccordion from "../components/modules/help/FaqAccordion";
import ContactCard from "../components/modules/help/ContactCard";
import faqData from "../data/faqData";

export default function Help() {
  const [query, setQuery] = useState("");
  const [ticketSubject, setTicketSubject] = useState("");
  const [ticketMessage, setTicketMessage] = useState("");

  const filteredFaqs = faqData.filter(
    (f) =>
      f.question.toLowerCase().includes(query.toLowerCase()) ||
      f.answer.toLowerCase().includes(query.toLowerCase())
  );

  const handleSubmitTicket = (e) => {
    e.preventDefault();
    console.log("Support ticket submitted:", { ticketSubject, ticketMessage });
    setTicketSubject("");
    setTicketMessage("");
  };

  return (
    <div>
      {/* Header */}
      <div className="bg-gradient-to-br from-[#1e1b4b] via-[#312e81] to-[#4c1d95] text-white rounded-2xl px-6 py-10 sm:px-8 mb-6">
        <span className="inline-flex items-center gap-2 text-xs font-semibold bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-4">
          <LifeBuoy className="w-3.5 h-3.5" /> Support Centre
        </span>
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-2">
          How can we help?
        </h1>
        <p className="text-indigo-100 mb-6 max-w-xl">
          Search our FAQs or reach out directly — our team typically responds
          within 24 hours.
        </p>

        <div className="flex items-center gap-2 bg-white rounded-xl px-4 py-3 max-w-xl">
          <Search className="w-4 h-4 text-gray-400 shrink-0" />
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search for answers..."
            className="w-full text-sm text-gray-900 focus:outline-none"
          />
        </div>
      </div>

      {/* Contact options */}
      <div className="grid sm:grid-cols-3 gap-4 mb-8">
        <ContactCard
          icon={Mail}
          iconBg="from-indigo-500 to-purple-600"
          title="Email us"
          detail="support@apic.ap.gov.in"
        />
        <ContactCard
          icon={Phone}
          iconBg="from-sky-400 to-blue-500"
          title="Call us"
          detail="+91 891 123 4567"
        />
        <ContactCard
          icon={MessageCircle}
          iconBg="from-fuchsia-500 to-pink-600"
          title="Live chat"
          detail="Mon-Sat, 9am-6pm IST"
        />
      </div>

      <div className="grid lg:grid-cols-3 gap-6">
        {/* FAQs */}
        <div className="lg:col-span-2">
          <h2 className="font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
          {filteredFaqs.length > 0 ? (
            <FaqAccordion faqs={filteredFaqs} />
          ) : (
            <div className="h-32 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
              No results for "{query}"
            </div>
          )}
        </div>

        {/* Raise a ticket */}
        <div className="bg-white border border-gray-100 rounded-2xl p-6 h-fit">
          <h2 className="font-bold text-gray-900 mb-1">Raise a ticket</h2>
          <p className="text-sm text-gray-500 mb-5">
            Can't find what you're looking for? Send us a message.
          </p>

          <form className="space-y-4" onSubmit={handleSubmitTicket}>
            <label className="block">
              <span className="block text-sm font-medium text-gray-700 mb-1.5">Subject</span>
              <input
                value={ticketSubject}
                onChange={(e) => setTicketSubject(e.target.value)}
                placeholder="e.g. Delay in EV Battery Enclosure v2"
                className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              />
            </label>

            <label className="block">
              <span className="block text-sm font-medium text-gray-700 mb-1.5">Message</span>
              <textarea
                value={ticketMessage}
                onChange={(e) => setTicketMessage(e.target.value)}
                placeholder="Describe your issue..."
                rows={4}
                className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm resize-y focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              />
            </label>

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-indigo-600 to-blue-500 text-white font-semibold text-sm py-3 rounded-xl hover:opacity-90 transition"
            >
              Submit Ticket
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}